import React, { Component } from "react";
import styled from "styled-components";
import NanoFlex from "../../Global/NanoFlex.js";
import { buildColumnsLinesPivot, buildPivotColumnsLines } from "../../Global/tools.js";
import administrationService from "../../../services/AdministrationService.js";

//COMPONENTS
import { AdminNavBar } from "./AdminNavBar.js";
import Type from "../../Global/Typography.js";
import Loading from "../../Global/Elements/Loading/Loading.js";
import { ReactComponent as ArrowDown } from "../../Global/icons/arrowDown.svg";
import ButtonIcon from "../../Global/Elements/Buttons/ButtonIcon.js";

// IMGS
import Save from "./../../Global/icons/save.svg";

const StyledReports = styled(NanoFlex)`
  min-width: 0;
  .reportsContent {
    min-width: 0;
    height: auto;
    .contentWrapper {
      padding: 32px;
      .reportsMenuWrapper {
        width: 208px;
        background-color: ${(props) => props.theme.color.colorsPalette.lightGrey};
        margin-right: 16px;
        padding: 16px;
        height: auto;
        .itemMenuReports {
          cursor: pointer;
          margin-bottom: 16px;
          background-color: ${(props) => props.theme.color.colorsPalette.lighterGrey};
          p {
            margin-top: 4px;
            text-align: center;
          }
          &:last-child {
            margin-bottom: 0px;
          }
          &:hover {
            opacity: 0.8;
          }
        }
        .activeItem {
          border-right: 4px solid ${(props) => props.theme.color.main.green};
          background-color: ${(props) => props.theme.color.main.white};
          pointer-events: none;
          h6 {
            font-weight: bold;
          }
          p {
            font-weight: bold;
          }
        }
      }
      .pivotConfiguration {
        margin-bottom: 0;
        .pivotConfigurationWrapper {
          .pivotHeader {
            .expandBtn {
              display: none;
            }
          }
          .configurationWrapper {
            height: calc(100vh - 164px);
            padding: 8px;
            .blockConfigurationWrapper {
              .blockListWrapper {
                max-height: 100%;
              }
            }
          }
        }
      }
    }
  }
`;

const StyledPivotConfiguration = styled(NanoFlex)`
  height: auto;
  margin-bottom: 8px;
  .pivotConfigurationWrapper {
    .pivotHeader {
      height: auto;
      background-color: ${(props) => props.theme.color.main.green};
      padding: 8px 16px;
      cursor: pointer;
      user-select: none;
      .titleWrapper {
        h5 {
          color: ${(props) => props.theme.color.main.white};
          text-transform: uppercase;
        }
      }
      .expandBtn {
        width: auto;
        padding-top: ${(props) => (props.isCollapsed ? "4px" : "0px")};
        svg {
          width: 16px;
          height: auto;
          transform: rotate(${(props) => (props.isCollapsed ? "0" : "180deg")});
          path {
            fill: ${(props) => props.theme.color.main.white};
          }
        }
      }
    }
    .configurationWrapper {
      height: ${(props) => (props.isCollapsed ? "0" : "auto")};
      overflow: hidden;
      padding: ${(props) => (props.isCollapsed ? "0" : "8px")};
      background-color: ${(props) => props.theme.color.colorsPalette.lighterGrey};
      .blockConfigurationWrapper {
        height: auto;
        overflow: auto;
        .headerBlock {
          height: auto;
          .titleBlock {
            p {
              text-transform: uppercase;
            }
          }
          .optionsWrapper {
            .optionBtnWrapper {
              width: auto;
              margin-right: 8px;
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
        .blockListWrapper {
          padding: 8px;
          max-height: 224px;
          overflow: auto;
          background-color: ${(props) => props.theme.color.main.white};
        }
      }
      .switchSortablesWrapper {
        margin: 0 16px;
        width: auto;
        height: auto;
        .switchBtn {
          cursor: pointer;
          padding: 16px;
          background-color: ${(props) => props.theme.color.colorsPalette.lightGrey};
          transition: ${(props) => props.theme.transition};
          svg {
            width: 24px;
            height: auto;
            path {
              fill: ${(props) => props.theme.color.main.font};
            }
          }
          &:hover {
            background-color: ${(props) => props.theme.color.main.font};
            transition: ${(props) => props.theme.transition};
            svg {
              path {
                fill: ${(props) => props.theme.color.main.white};
              }
            }
          }
        }
      }
    }
  }

  textarea {
    border: 1px solid ${(props) => (props.error ? props.theme.color.colorsPalette.red : props.theme.color.main.font)};
    padding: 8px;
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: ${(props) => props.theme.color.main.font};
    font-family: ${(props) => props.theme.font};
    background-color: ${(props) => (props.error ? "#FFFDDC" : props.disabled ? props.theme.color.colorsPalette.lighterGrey : props.theme.color.main.white)};
    pointer-events: ${(props) => (props.disabled ? "none" : "unset")};
    text-align: ${(props) => (props.center ? "center" : "left")};
    &::placeholder {
      font-family: ${(props) => props.theme.font};
      color: ${(props) => props.theme.color.colorsPalette.grey};
    }

    &:focus {
      border: 1px solid ${(props) => props.theme.color.main.font};
    }
  }
`;

export class ReportsPrompts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      reportsPrompts: [],
      selectedReportId: null,
    };
  }

  componentDidMount() {
    this.getReportsPrompts();
  }

  getReportsPrompts = () => {
    this.setState({ isLoading: true });
    administrationService
      .getReportsPrompts()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ reportsPrompts: data, selectedReportId: data?.[0]?.id || null, isLoading: false });
      });
  };

  saveReportPrompt = () => {
    const selectedReport = this.state.reportsPrompts.find((r) => r.id === this.state.selectedReportId);
    if (!selectedReport?.prompt) return;

    this.setState({ isLoading: true });
    administrationService
      .saveReportPrompt(selectedReport.prompt)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ isLoading: false });
      });
  };

  render() {
    const selectedReport = this.state.reportsPrompts.find((r) => r.id === this.state.selectedReportId);

    if (this.state.isLoading === true)
      return (
        <StyledReports>
          <Loading />
        </StyledReports>
      );

    return (
      <StyledReports>
        <NanoFlex className="reportsContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <AdminNavBar render={this.props.render} />
          <NanoFlex className="contentWrapper" justifyContent="flex-start" alignItems="stretch" alignContent="stretch">
            <NanoFlex className="reportsMenuWrapper" flexDirection="column">
              {this.state.reportsPrompts.map((s) => {
                return (
                  <NanoFlex key={`prompts${s.id}`} className={`itemMenuReports ${this.state.selectedReportId === s.id ? "activeItem" : ""}`} flexDirection="column" onClick={() => this.setState({ selectedReportId: s.id })}>
                    <Type.h6>{s.name}</Type.h6>
                  </NanoFlex>
                );
              })}
            </NanoFlex>
            <StyledPivotConfiguration className="pivotConfiguration">
              <NanoFlex className="pivotConfigurationWrapper" flexDirection="column">
                <NanoFlex className="pivotHeader">
                  <NanoFlex className="titleWrapper">
                    <Type.h5>
                      <b>Prompts</b>
                    </Type.h5>
                  </NanoFlex>
                  <NanoFlex className="expandBtn">
                    <ArrowDown />
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="configurationWrapper" alignItems="stretch">
                  <NanoFlex className="blockConfigurationWrapper" flexDirection="column" justifyContent="flex-start">
                    <NanoFlex className="headerBlock" justifyContent="space-between">
                      <NanoFlex className="titleBlock" justifyContent="flex-start">
                        <Type.p>
                          <b>{this.props.title}</b>
                        </Type.p>
                      </NanoFlex>
                      <NanoFlex className="optionsWrapper" justifyContent="flex-end">
                        <NanoFlex className="optionBtnWrapper" onClick={() => this.saveReportPrompt()}>
                          <ButtonIcon src={Save} />
                        </NanoFlex>
                      </NanoFlex>
                    </NanoFlex>
                    <NanoFlex className="blockListWrapper" justifyContent="flex-start" alignItems="flex-start" flexDirection="column">
                      <textarea
                        onChange={(e) => {
                          const newPromptValue = e.target.value;
                          this.setState((prevState) => {
                            const updatedReports = prevState.reportsPrompts.map((report) => {
                              if (report.id === prevState.selectedReportId) {
                                return {
                                  ...report,
                                  prompt: {
                                    ...(report.prompt || {}),
                                    text: newPromptValue,
                                  },
                                };
                              }
                              return report;
                            });

                            return { reportsPrompts: updatedReports };
                          });
                        }}
                        className="full"
                        value={selectedReport?.prompt?.text || ""}
                      />
                    </NanoFlex>
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
            </StyledPivotConfiguration>
          </NanoFlex>
        </NanoFlex>
      </StyledReports>
    );
  }
}
